export default "__VITE_ASSET__Da0Y14gN__"